import { Map } from 'immutable';
import { State } from 'flow/types/State';

type PriorityEntries = Map<string, Map<string, unknown>>;

const EMPTY: PriorityEntries = Map();

export const selectPriorityCallRoutings = (state: State): PriorityEntries =>
    (state.callRoutings.get('priority') as unknown as PriorityEntries) ?? EMPTY;

export const selectCallRoutingsLoaded = (state: State) =>
    state.callRoutings.has('priority');
